/**
 * "View member profile" for the admin user page: resolves the login's member record
 * (GET api/members/by-user/{userId}) and opens /admin/members/:memberId. Renders nothing when the
 * login has no member record.
 */
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { IconAddressBook } from '@tabler/icons-react';
import { Button } from '../../../../components/ui';
import { useMemberService } from '@actschurch/ccms-sdk';
import { errorMessage, errorStatus } from '../../../../components/members';

export function ViewMemberProfileButton({ userId }: { userId: string }) {
  const navigate = useNavigate();
  const memberService = useMemberService();
  const member = useQuery({
    queryKey: ['hr', 'admin', 'member-by-user', userId],
    queryFn: async () => {
      try {
        return await memberService.getByUserId(userId);
      } catch (e) {
        if (errorStatus(e) === 404 || /not found/i.test(errorMessage(e, ''))) return null;
        throw e;
      }
    },
    enabled: !!userId,
    retry: false,
    staleTime: 60_000,
  });

  if (!member.data) return null;
  return (
    <Button variant="light" size="sm" leftSection={<IconAddressBook size={16} />} onClick={() => navigate(`/admin/members/${member.data!.memberID}`)}>
      View member profile
    </Button>
  );
}
